import React, { useEffect, useState } from "react";
import { fetchApi } from "../../../utils/methods";
import { toast } from "react-toastify";
import { GetHealthCoachesData } from "../../../redux/constants/apiConstants";
import { MainSectionView2 } from "../../PeopleHomeV2/styles";
import { UserButton } from "../../EngagementSection/styles";
import PeopleGridView from "../../../components/PeopleGridViewV2/communityGridView";
import { PaginationCircleNew } from "../../Journeys/styles";
import { CoachHeading } from "./style";
import PropTypes from "prop-types";
import Waiting from "../../Waiting";



function CoachDirectory({history}) {
  const [healthCoachData, setHealthCoachData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 20;
  const [loading, setLoading] = useState(true);






  const GetHealthCoachData = async (page) => {
    const payload = {
      // company_id: 1,
      name: "",
      page: page,
      limit: limit,
    };

    try {
      setLoading(true);
      const res = await fetchApi(GetHealthCoachesData, "POST", payload);
      window.console.log("GetHealthCoachData", res);
      if (res.status === "failed") {
        toast.error(res?.data?.message);
        setLoading(false);
      } else {
        setHealthCoachData(res.data.health_coaches || []);
        setTotalPages(res.data.pagination.total_pages); 
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };



  useEffect(() => {
    GetHealthCoachData(pageNo);
  }, [pageNo]);



  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPageNo(newPage);
    }
  };


  const getPaginationCircle = () => {
    if (!totalPages || totalPages <= 1) return null;

    const windowSize = 6;
    // if total pages <= window, just show all
    if (totalPages <= windowSize) {
      return Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
        <PaginationCircleNew key={p} active={p === pageNo} onClick={() => handlePageChange(p)}>
          <div>{p}</div>
        </PaginationCircleNew>
      ));
    }

    // compute start so we show 6 pages, biasing so pages shift left when current is larger
    const maxStart = totalPages - windowSize + 1; // e.g. 12-6+1=7
    let start = pageNo - 4; // bias similar to your example (page 7 -> start 3)
    if (start < 1) start = 1;
    if (start > maxStart) start = maxStart;
    const pages = [];
    for (let i = start; i < start + windowSize; i++) {
      pages.push(i);
    }

    const nodes = pages.map((p) => (
      <PaginationCircleNew key={p} active={p === pageNo} onClick={() => handlePageChange(p)}>
        <div>{p}</div>
      </PaginationCircleNew>
    ));

    // if window end < totalPages, show ellipsis + last page
    const windowEnd = start + windowSize - 1;
    if (windowEnd < totalPages) {
      nodes.push(
        <div key="dots" style={{ padding: "6px 0px", cursor: "default", fontWeight: 400,color:"#F37A65",fontSize:"16px" }}>
          ...
        </div>
      );
      nodes.push(
        <PaginationCircleNew key={`last-${totalPages}`} active={totalPages === pageNo} onClick={() => handlePageChange(totalPages)}>
          <div>{totalPages}</div>
        </PaginationCircleNew>
      );
    }

    return nodes;
  };
  


  // const getPaginationCircle = () => {
  //   let circleButtons = [];
  //   for (let i = 1; i <= totalPages; i++) {
  //     circleButtons.push(
  //       <PaginationCircleNew
  //         key={i}
  //         active={i === pageNo}
  //         onClick={() => handlePageChange(i)}
  //       >
  //         <div>{i}</div>
  //       </PaginationCircleNew>
  //     );
  //   }
  //   return circleButtons;
  // };

  

  return (

    loading ?
      <Waiting/>:
      <>
        <CoachHeading>Hire a coach, transform your workplace.</CoachHeading>
  
        <div style={{ width: "100%", display: "flex",textAlign:"center",margin:"20px 0px" }}>
          <MainSectionView2 isMargin={"0px"}>
            <PeopleGridView
              employeeList={healthCoachData}
              showEmployeeDetails={() => {}}
              selectedEmployee={null}
              searchAmigo={false}
              sendFriendRequestPost={() => {}}
              history={history}
              show={true}
              plp={{}}
              healthCoachRole={true}
            />
  
            {/* Pagination */}
            {totalPages > 1 && (
              <div className="pagination" style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
                {pageNo > 1 && (
                  <UserButton
                    width="32px"
                    height="32px"
                    Align={1}
                    padding="4px"
                    float={1}
                    fontSize="18px"
                    bgColor="transparent"
                    isDisplay="flex"
                    isJustify="center"
                    isAlign="center"
                    capitalize={1}
                    onClick={() => handlePageChange(pageNo - 1)}
                   
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                      <path
                        d="M8 12.8951V1.10468C7.99913 0.896107 7.93642 0.692477 7.81982 0.51954C7.70322 0.346602 7.53796 0.212123 7.34494 0.133106C7.15191 0.0540895 6.93979 0.0340843 6.73539 0.0756197C6.531 0.117155 6.34351 0.218367 6.19663 0.366455L0.31195 6.25114C0.213103 6.34918 0.134647 6.46582 0.0811065 6.59433C0.0275657 6.72284 0 6.86068 0 6.9999C0 7.13912 0.0275657 7.27697 0.0811065 7.40548C0.134647 7.53399 0.213103 7.65063 0.31195 7.74867L6.19663 13.6334C6.34351 13.7814 6.531 13.8827 6.73539 13.9242C6.93979 13.9657 7.15191 13.9457 7.34494 13.8667C7.53796 13.7877 7.70322 13.6532 7.81982 13.4803C7.93642 13.3073 7.99913 13.1037 8 12.8951Z"
                        fill="#F37A65"
                      />
                    </svg>
                  </UserButton>
                )}
  
  
                {getPaginationCircle()}
             
  
                {pageNo < totalPages  && (
                  <UserButton
                    width="32px"
                    height="32px"
                    Align={1}
                    padding="4px"
                    fontSize="18px"
                    bgColor="transparent"
                    capitalize={1}
                    isDisplay="flex"
                    isJustify="center"
                    isAlign="center"
                    onClick={() => handlePageChange(pageNo + 1)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                      <path
                        d="M0 1.10487L0 12.8953C0.000874519 13.1039 0.0635757 13.3075 0.180175 13.4805C0.296775 13.6534 0.462038 13.7879 0.655064 13.8669C0.848091 13.9459 1.06021 13.9659 1.26461 13.9244C1.469 13.8828 1.65649 13.7816 1.80337 13.6335L7.68805 7.74886C7.7869 7.65082 7.86535 7.53418 7.91889 7.40567C7.97243 7.27716 8 7.13932 8 7.0001C8 6.86088 7.97243 6.72303 7.91889 6.59452C7.86535 6.46601 7.7869 6.34937 7.68805 6.25133L1.80337 0.366647C1.65649 0.218558 1.469 0.117347 1.26461 0.075811C1.06021 0.0342753 0.848091 0.0542803 0.655064 0.133297C0.462038 0.212314 0.296775 0.346793 0.180175 0.519731C0.0635757 0.692668 0.000874519 0.896297 0 1.10487Z"
                        fill="#F37A65"
                      />
                    </svg>
                  </UserButton>
                )}
              </div>
            )}
          </MainSectionView2>
        </div>
      </>
  );
}

CoachDirectory.propTypes = {
  history: PropTypes.object,
};



export default CoachDirectory;

